import { createSlice } from "@reduxjs/toolkit";
import {
  SetPasswordAction,
  UserInfoEditAction,
  activityListAction,
  packNotificationAction,
  schoolDetailAction,
  signinAction,
  userLogTimeUpdateAction,
} from "../Action/authAction";
const initialState = {
  hours: 0,
  userData: {},
  loading: false,
  error: null,
  SetPasswordStatus: "idle",
  UserInfoEditStatus: "idle",
  userLogTimeUpdateStatus: "idle",
  schoolDetail: {},
  schoolDetailStatus: "idle",
  notification: {},
  notificationStatus: "idle",
  activityList: [],
};

const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    storeUser: (state, action) => {
      state.userData = action.payload ? { payload: action.payload } : {};
    },
    setHours: (state, payload) => {
      state.hours = payload?.payload;
    },
    clearTimes: (state) => {
      state.hours = 0;
    },
    resetAuthSession: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(signinAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signinAction.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(signinAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(SetPasswordAction.fulfilled, (state, action) => {
        state.SetPasswordStatus = "succeeded";
      })
      .addCase(UserInfoEditAction.fulfilled, (state, action) => {
        state.UserInfoEditStatus = "succeeded";
      })
      .addCase(schoolDetailAction.pending, (state) => {
        state.schoolDetailStatus = "loading";
      })

      .addCase(schoolDetailAction.fulfilled, (state, action) => {
        state.schoolDetail = action.payload.data;
        state.schoolDetailStatus = "succeeded";
      })
      .addCase(schoolDetailAction.rejected, (state) => {
        state.schoolDetailStatus = "failed";
      })
      .addCase(packNotificationAction.pending, (state) => {
        state.notificationStatus = "loading";
      })

      .addCase(packNotificationAction.fulfilled, (state, action) => {
        state.notification = action.payload.data;
        state.notificationStatus = "succeeded";
      })
      .addCase(packNotificationAction.rejected, (state) => {
        state.notificationStatus = "failed";
      })

      .addCase(activityListAction.fulfilled, (state, action) => {
        state.activityList = action.payload.data;
      })

      .addCase(userLogTimeUpdateAction.fulfilled, (state, action) => {
        state.userLogTimeUpdateStatus = "succeeded";
      });
  },
});

export const { storeUser, storeToken, setHours, clearTimes, resetAuthSession } =
  authSlice.actions;
export default authSlice.reducer;
